var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{ref:"phone",staticClass:"pb-0",attrs:{"dense":"","type":"text","label":_vm.lang.txnPhone,"rules":_vm.phoneRules,"value":_vm.inputValue,"validate-on-blur":"","prepend-inner-icon":"fa-mobile"},on:{"keydown":_vm.checkNumberInput,"keyup":function($event){$event.target.value = $event.target.value.substring(0, 19);
    _vm.formatValue($event.target.value);
    _vm.$emit('input', $event.target.value.replace(/\D/g, ''));}}})
}
var staticRenderFns = []

export { render, staticRenderFns }